// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Asistente',
  },
  close: {
    amigo: 'Cerrar Amigo',
    assistant: 'Cerrar el asistente',
  },
  brand: 'Marca',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Chats',
  new_chat: 'Nuevo chat',
  back: 'Volver al chat',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Nuevas respuestas en otro chat',
  news_elsewhere_other: 'Nuevas respuestas en {{count}} chats más',
};
